<div class="c__body">
  <sd-title [titleLevel]="titleLevel" customClass="brand--h4 c__title is-light" [attr.aria-hidden]="isTitleAriaHidden">
    {{productInfo?.title}}
  </sd-title>

  <sd-price
    [isSSR]="false"
    [discountedPrice]="productInfo?.discountedPrice"
    [price]="productInfo?.price"
    [isSmall]="true"
    [recommendedPrice]="productInfo?.recommendedPrice"
    [isDiscountWithRecommendedPrice]="productInfo?.isDiscountWithRecommendedPrice"
    (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
  />

  @if (productInfo?.isTaxesIncluded) {
    <span class="is-caption c__taxes-included">
      {{'product.taxesIncluded' | translate }}
    </span>
  }

  @if (productInfo?.link?.url) {
    <a class="is-full-area" [routerLink]="productInfo?.link?.url">
      <span>{{productInfo.link?.linkName}}</span>
    </a>
  }
</div>

@if (productInfo?.media?.url || productInfo?.media?.urlTwicPic) {
  <div class="c__media-wrapper">
    <sd-banner
      [media]="productInfo?.media"
      [isFit]="true"
      [imgRatio]="imageRatio"
      [hasAltText]="false"
    />
  </div>
}
